import React from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import * as qs from "query-string"
import "./index.scss"
import PageContainer from "components/common/PageContainer"
import HeroHeader from "components/hero-header"
import TopicCard from "components/card/topic-card"
import Spinner from "components/common/spinner"
import { FORUM_MODAL_TYPES, RESPONSE_MODAL_TYPES } from "constants/modal-types"

import {
  showForumModal,
  setForumQuestionData,
  upvoteForumQuestion,
  downvoteForumQuestion,
  searchSchoolForums,
  searchSchoolForumsTag,
  closeForumQuestion,
} from "store/school/actions"

import { showConfirmModal, closeConfirmModal } from "store/user/actions"

import history from "app/history"

class ForumSearch extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchParam: "",
      searchMode: false,
      enableSearch: false,
      enableButton: true,
      keyword: null,
    }
  }

  componentDidMount() {
    const queryParams = qs.parse(this.props.location.search)
    const { keyword, tag } = queryParams

    if (keyword && keyword !== "") {
      this.searchForums(keyword)
    } else if (tag && tag !== "") {
      this.searchForumsTag(tag)
    }

    document.addEventListener("scroll", this.trackScrolling)
  }

  searchForumsTag(tag) {
    const {
      school: { schoolData },
      searchSchoolForumsTag,
    } = this.props

    let slug = tag.toLowerCase().split(" ").join("-")

    searchSchoolForumsTag({ schoolId: schoolData?.id, slug })

    this.setState({
      searchMode: "tag",
      keyword: tag,
    })
  }

  searchForums(keyword) {
    const {
      school: { schoolData },
      searchSchoolForums,
    } = this.props
    searchSchoolForums({ schoolId: schoolData.id, keyword })

    this.setState({
      searchMode: "keyword",
      keyword,
    })
  }

  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight
  }

  componentDidUpdate(prevProps) {
    const oldQueryParams = qs.parse(prevProps.location.search)
    const { keyword: oldKeyword, tag: oldTag } = oldQueryParams

    const queryParams = qs.parse(this.props.location.search)
    const { keyword, tag } = queryParams

    if (keyword && keyword !== oldKeyword) {
      this.searchForums(keyword)
    } else if (tag && tag !== oldTag) {
      this.searchForumsTag(tag)
    } else if (this.props.school.schoolData !== prevProps.school.schoolData) {
      if (keyword) {
        this.searchForums(keyword)
      } else if (tag) {
        this.searchForumsTag(tag)
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener("scroll", this.trackScrolling)
  }

  fetchMoreData = () => {
    const {
      school: { forums = {} },
    } = this.props

    const { searchMode, keyword } = this.state

    if (forums.meta.page < forums.meta.pages) {
      if (searchMode === "keyword") {
        this.searchForums(keyword)
      } else if (searchMode === "tag") {
        this.searchForumsTag(keyword)
      }
    }
  }

  handleEditQuestion = (question, source) => {
    const { showForumModal, setForumQuestionData } = this.props

    setForumQuestionData({ ...question, source })

    showForumModal({
      type: FORUM_MODAL_TYPES.QUESTION,
      isEdit: true,
    })
  }

  trackScrolling = () => {
    const wrappedElement = document.getElementById("forums")
    if (this.isBottom(wrappedElement)) {
      this.fetchMoreData()
      document.removeEventListener("scroll", this.trackScrolling)
    }
  }

  enableSearch = () => {
    this.setState({
      enableSearch: true,
      enableButton: false,
    })
  }

  disableSearch = () => {
    this.setState({
      enableSearch: false,
      enableButton: true,
    })
  }

  handleCloseQuestion = (question, source) => {
    const {
      setForumQuestionData,
      closeForumQuestion,
      showConfirmModal,
    } = this.props

    showConfirmModal({
      modalType: RESPONSE_MODAL_TYPES.WARNING,
      header: "Close this question?",
      message:
        "Other students will still be able to post comments or submit answers.",
      confirmLabel: "Yes, close it",
      onConfirm: () => {
        setForumQuestionData({ ...question, source })
        closeForumQuestion(question.id)
      },
    })
  }

  handleSearch = async (e) => {
    const { name, value } = e.currentTarget

    if (e.key === "Enter" && value !== "") {
      if (this.state.typingTimeout) {
        clearTimeout(this.state.typingTimeout)
      }

      await this.setState({
        [name]: value,
        enableSearch: true,
        enableButton: false,
      })

      history.push(`/forums/search?keyword=${value}`)
    }
  }

  renderSearchResults() {
    const {
      school: {
        forums: { data, count = 0 },
        isLoadingForums,
      },
      auth: { studentId },
      upvoteForumQuestion,
      downvoteForumQuestion,
    } = this.props

    const { keyword } = this.state

    return (
      <div className="search-result-container">
        <div className="result-header">
          <h2>Search Result</h2>
          <p className="mt-s">
            {data?.length
              ? `We found ${count} ${count > 1 ? "results" : "result"} for ${
                  keyword ? keyword.replaceAll("-", " ") : ""
                }`
              : "Sorry, no result found"}
          </p>
        </div>
        <div className="topic-list">
          {data?.length
            ? data?.map((question, i) => {
                return (
                  <TopicCard
                    key={i}
                    author={question.user?.full_name || question.user?.username}
                    pubTimestamp={question.pub_date}
                    editTimestamp={question.updated}
                    views={question.view_count}
                    reply={question.answer_count}
                    title={question.title}
                    content={question.description}
                    tags={question.tags}
                    id={question.id}
                    upvotes={question.positive_votes}
                    downvotes={question.negative_votes}
                    isAuthor={question.user?.id === parseInt(studentId)}
                    isClosed={question.closed}
                    onClick={() => this.handleClickQuestion(question.id)}
                    onClickEdit={() =>
                      this.handleEditQuestion(question, "latest")
                    }
                    onClickClose={() =>
                      this.handleCloseQuestion(question, "latest")
                    }
                    onClickUpvote={() =>
                      upvoteForumQuestion({ id: question.id, source: "latest" })
                    }
                    onClickDownvote={() =>
                      downvoteForumQuestion({
                        id: question.id,
                        source: "latest",
                      })
                    }
                  />
                )
              })
            : ""}
          <Spinner isFetching={isLoadingForums} />
        </div>
      </div>
    )
  }

  render() {
    const {
      location: { search },
      school: { schoolData = {}, isLoadingForums },
    } = this.props

    const routeList = {
      "/": "Home",
      "/forums": "Forums",
      "/forums/search/": search.includes("tag") ? "Tag" : "Search",
    }

    const { searchParam } = this.state

    return (
      <div id="forums">
        <PageContainer>
          <HeroHeader
            title="Forums"
            description={
              search.includes("tag")
                ? "Browsing a specific topics."
                : "Browsing through searched topics."
            }
            routeList={routeList}
            activeColor={schoolData.primary_color}
            activeItem={search.includes("tag") ? "Tag" : "Search"}
            onChange={this.handleSearch}
            searchValue={searchParam}
            searchEnabled
          />
          {!isLoadingForums ? (
            this.renderSearchResults()
          ) : (
            <Spinner
              style={{ padding: "48px 0" }}
              isFetching={isLoadingForums}
            />
          )}
        </PageContainer>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.authReducer,
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showForumModal,
      setForumQuestionData,
      upvoteForumQuestion,
      downvoteForumQuestion,
      searchSchoolForums,
      searchSchoolForumsTag,
      closeForumQuestion,
      showConfirmModal,
      closeConfirmModal,
    },
    dispatch
  )

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ForumSearch
)
